import { render, staticRenderFns } from "./ManagePrinters.vue?vue&type=template&id=6ffd0fb1&scoped=true&"
import script from "./ManagePrinters.vue?vue&type=script&lang=js&"
export * from "./ManagePrinters.vue?vue&type=script&lang=js&"
import style0 from "./ManagePrinters.vue?vue&type=style&index=0&id=6ffd0fb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffd0fb1",
  null
  
)

export default component.exports